import { render } from "./VerifyEmail.vue?vue&type=template&id=9f895776"
import script from "./VerifyEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/VerifyEmail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9f895776"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9f895776', __exports__)) {
    api.reload('9f895776', __exports__)
  }
  
  module.hot.accept("./VerifyEmail.vue?vue&type=template&id=9f895776", () => {
    api.rerender('9f895776', render)
  })

}


export default __exports__